export default __webpack_public_path__ + "static/media/A0000.1c2db6ed.png";